import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  handleChildNavigation: (event: MessageEvent) => void;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  hostOrigin: string;
  isIframeLoaded: boolean;
  isEmbedded?: boolean;
}

export const useIframePageEffects = ({
  handleChildNavigation,
  iframeRef,
  hostOrigin,
  isIframeLoaded,
  isEmbedded = false,
}: Props) => {
  const location = useLocation();

  useEffect(() => {
    window.addEventListener('message', handleChildNavigation);
    return () => {
      window.removeEventListener('message', handleChildNavigation);
    };
  }, [handleChildNavigation]);

  useEffect(() => {
    if (isEmbedded || !isIframeLoaded) return;

    const win = iframeRef.current?.contentWindow;
    if (!win) return;

    win.postMessage(
      {
        type: 'ROUTE_CHANGE',
        path: location.pathname,
        search: location.search,
        hash: location.hash,
      },
      hostOrigin
    );
  }, [
    location.pathname,
    location.search,
    location.hash,
    hostOrigin,
    iframeRef,
    isIframeLoaded,
    isEmbedded,
  ]);
};
